export const server = process.env.NODE_ENV == "development" ? 'https://localhost:7043' : '';

export const webAPIUrl = `${server}/api`;